/**
 * Vite exposes import.meta.env.VITE_* at build time. For local dev these
 * default to the production API; override with .env.local for hitting a
 * local API instead.
 */
const env = import.meta.env;

/**
 * Fleet Admin Domains (A2): one static bundle serves the central app AND
 * tenant admin hosts (admin.<fleet-domain>). On a tenant host the API is
 * reached same-origin via Caddy's /api proxy — the Host header is the
 * tenant selector and no CORS entry is ever needed (F1 ruling). The
 * central host (and local dev, which pins VITE_API_URL) keeps an
 * absolute base.
 */
const CENTRAL_HOSTS = new Set(['app.breakernetwork.app', 'localhost', '127.0.0.1']);

export function isTenantAdminHost(): boolean {
  return (
    typeof window !== 'undefined' && !CENTRAL_HOSTS.has(window.location.hostname)
  );
}

export const config = {
  // No trailing slash; consumers CONCATENATE (config.apiUrl + path). Never
  // pass this as a base to `new URL(path, base)` — an absolute path drops
  // the /api prefix a tenant-host base carries.
  apiUrl: isTenantAdminHost()
    ? `${window.location.origin}/api`
    : ((env.VITE_API_URL as string | undefined) ?? 'https://api.breakernetwork.app').replace(/\/$/, ''),
  trackUrl: (env.VITE_TRACK_URL as string | undefined) ?? 'https://track.breakernetwork.app',
  // Map tiles. Defaults to OpenStreetMap's public tile server, which is fine for
  // dev/low-volume but NOT permitted for production traffic under OSM's tile usage
  // policy. Before prod, set VITE_TILE_URL/VITE_TILE_ATTRIBUTION to a keyed provider
  // (MapTiler, Stadia, Thunderforest, etc.) — no code change needed, just env.
  tileUrl:
    (env.VITE_TILE_URL as string | undefined) ??
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  tileAttribution:
    (env.VITE_TILE_ATTRIBUTION as string | undefined) ??
    '&copy; OpenStreetMap contributors',
} as const;
